<div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
        <div class="d-flex align-items-center contact-title-wrapper">
            <img src="assets/svg/money-icon.svg" width="20" class="contact-section-icon">
            <h3 class="text-semibold contact-title">Historial del presupuestos</h3>
        </div>
    </div>

    <div class="prospectos-table  mt-3">
        <table class="stage-history-table">
            <thead>
                <tr>
                    <th></th>
                    <th>
                        <div class="th-content">
                            <span>nombre</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Numero de presupuesto</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Probabilidad(%)</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Fecha de ultima modificacion</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Última modificacion por</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Total presupuesto</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Estado</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor=" let v of versiones, let i=index" >
                <td class="counter-cell">{{ i + 1 }}.</td>
                <td>
                <div class="d-flex flex-row align-items-center color-org">
                <u>{{v?.cambio_descripcion}}</u>
                </div>
            </td>
            <td>{{ v.cabecera?.presupuesto_id }}</td>
            <td>{{ v.cabecera?.probabilidad || 0 }}%</td>
            <td>{{ v.cabecera?.fecha_creacion | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ v.modificado_por?.nombre }} {{ v.modificado_por?.apellido }}</td>
            <td>
            {{ v.cabecera?.totales?.precio_total | currency:'CLP ' }}
            </td>
            <td>{{ v.cabecera?.estado}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
